import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const listboxDefaultVariants = {}
const listboxCompoundVariants = []

const listboxSlotNames = [
  [
    "root",
    "Listbox__root"
  ],
  [
    "target",
    "Listbox__target"
  ],
  [
    "hiddenInput",
    "Listbox__hiddenInput"
  ],
  [
    "dropdown",
    "Listbox__dropdown"
  ],
  [
    "items",
    "Listbox__items"
  ],
  [
    "item",
    "Listbox__item"
  ],
  [
    "group",
    "Listbox__group"
  ],
  [
    "loading",
    "Listbox__loading"
  ],
  [
    "noResults",
    "Listbox__noResults"
  ]
]
const listboxSlotFns = /* @__PURE__ */ listboxSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, listboxDefaultVariants, getSlotCompoundVariant(listboxCompoundVariants, slotName))])

const listboxFn = memo((props = {}) => {
  return Object.fromEntries(listboxSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const listboxVariantKeys = []
const getVariantProps = (variants) => ({ ...listboxDefaultVariants, ...compact(variants) })

export const listbox = /* @__PURE__ */ Object.assign(listboxFn, {
  __recipe__: false,
  __name__: 'listbox',
  raw: (props) => props,
  variantKeys: listboxVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, listboxVariantKeys)
  },
  getVariantProps
})